import { AccountCircle } from '@mui/icons-material';
import { grey } from '@mui/material/colors';

import { AvantarProps } from '../../../config/interfaces';
import './index.scss';

const Avatar = (props: AvantarProps) => {
  const {
    url,
    style,
    size = 40,
    mrSVG = 1,
  } = props;

  const contentUrl = url ? (
    <img
      src={url}
      style={{
        width: `${size - 10}px`,
        height: `${size - 10}px`,
        marginRight: '7px',
        marginLeft: '3px',
        objectFit: 'cover',
        borderRadius: '100px',
        boxShadow: '0px 3px 6px #000029',
        aspectRatio: '1',
        ...style,
      }}
      alt="avatar"
    />
  ) : <AccountCircle sx={{ fontSize: size, color: grey[500], mr: mrSVG }} />;

  return (
    <>
      {contentUrl}
    </>
  )
}

export default Avatar;
